import React, {forwardRef} from 'react';

import {cn} from '../lib/utils';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

const labelStyles = ['text-sm font-medium leading-none text-(--compass-on-surface)'];

// Association is native: a consumer-supplied `htmlFor` matching an input `id`
// is what gives that input its accessible name. The primitive adds no wiring
// of its own.
export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  {className, ...props},
  ref
) {
  return <label {...props} className={cn(labelStyles, className)} ref={ref} />;
});
